import React from 'react';
import { Container, Row } from 'react-bootstrap';
import quantumCityLogo from '../assets/quantum-city-white.png';
import uCalgaryLogo from '../assets/u-calgary-white.png';
import albertaInnovatesLogo from '../assets/alberta-innovates.png';
import './Footer.css';

function Footer() {
  return (
    <footer>
      <Container>
        <Row className="justify-content-center align-items-center">
          <div className="col-sm-4">
            <div className="logo-container">
              <img src={quantumCityLogo} alt="Quantum City Logo" className="logo-image" />
            </div>
          </div>
          <div className="col-sm-4">
            <div className="logo-container">
              <img src={uCalgaryLogo} alt="University of Calgary Logo" className="logo-image" />
            </div>
          </div>
          <div className="col-sm-4">
            <div className="logo-container">
              <img src={albertaInnovatesLogo} alt="Alberta Innovates Logo" className="logo-image" />
            </div>
          </div>
        </Row>
        <Row>
          <div className="col-sm-12 copyright">
            &copy; {(new Date()).getFullYear()} Quantum City Challenge | <a href="https://io.ucalgary.ca/quantum-city/contact">Contact us</a>
          </div>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
